import React, { useState } from 'react';
import clubService from '../../services/clubService';
import { useNotification } from '../../context/NotificationContext';

const ClubEvents = ({ club, onClose, onRefresh }) => {
  const [loading, setLoading] = useState({});

  const { showSuccess } = useNotification();

  const handleDeleteEvent = async (event) => {
    if (window.confirm(`Are you sure you want to delete "${event.title}"?`)) {
      try {
        setLoading(prev => ({ ...prev, [`delete_${event.eventId}`]: true }));
        
        const response = await clubService.deleteEvent(club.id, event.eventId);

        if (response.success) {
          showSuccess('Event deleted successfully!');
          onRefresh();
        }
      } catch (error) {
        console.error('Error deleting event:', error);
      } finally {
        setLoading(prev => ({ ...prev, [`delete_${event.eventId}`]: false }));
      }
    }
  };

  const getStatusBadge = (status) => {
    const statusConfig = {
      'ACTIVE': { bg: 'success', icon: 'fa-check-circle', text: 'Active' },
      'COMPLETED': { bg: 'info', icon: 'fa-flag-checkered', text: 'Completed' },
      'CANCELLED': { bg: 'danger', icon: 'fa-times-circle', text: 'Cancelled' },
      'DRAFT': { bg: 'secondary', icon: 'fa-edit', text: 'Draft' }
    };
    
    const config = statusConfig[status] || statusConfig['DRAFT'];
    
    return (
      <span className={`badge bg-${config.bg} bg-opacity-10 text-${config.bg} fw-bold`}>
        <i className={`fas ${config.icon} me-1`}></i>
        {config.text}
      </span>
    );
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  return (
    <div className="club-events">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h5 className="mb-0">
          <i className="fas fa-calendar-alt me-2"></i>
          Club Events ({club.events?.length || 0})
        </h5>
        <button
          className="btn btn-outline-secondary btn-sm"
          onClick={onClose}
        >
          <i className="fas fa-times"></i>
        </button>
      </div>

      {club.events && club.events.length > 0 ? (
        <div className="table-responsive">
          <table className="table table-hover align-middle">
            <thead className="bg-light">
              <tr>
                <th className="fw-bold">Event</th>
                <th className="fw-bold">Status</th>
                <th className="fw-bold">Start Date</th>
                <th className="fw-bold">End Date</th>
                <th className="fw-bold text-center">Participants</th>
                <th className="fw-bold text-center">Actions</th>
              </tr>
            </thead>
            <tbody>
              {club.events.map((event) => (
                <tr key={event.eventId}>
                  <td>
                    <div className="d-flex align-items-center">
                      <div 
                        className="bg-info bg-opacity-10 rounded-circle d-flex align-items-center justify-content-center me-3"
                        style={{ width: '40px', height: '40px' }}
                      >
                        <i className="fas fa-calendar-alt text-info"></i>
                      </div>
                      <div>
                        <div className="fw-bold">{event.title}</div>
                        <small className="text-muted">ID: {event.eventId}</small>
                      </div>
                    </div>
                  </td>
                  <td>
                    {getStatusBadge(event.status)}
                  </td>
                  <td>
                    <span className="text-dark">{formatDate(event.startDate)}</span>
                  </td>
                  <td>
                    <span className="text-dark">{formatDate(event.endDate)}</span>
                  </td>
                  <td className="text-center">
                    <span className="badge bg-primary bg-opacity-10 text-primary fw-bold">
                      {event.totalParticipants || 0}
                    </span>
                  </td>
                  <td className="text-center">
                    <button
                      className="btn btn-outline-danger btn-sm"
                      onClick={() => handleDeleteEvent(event)}
                      disabled={loading[`delete_${event.eventId}`]}
                      title="Delete Event"
                    >
                      {loading[`delete_${event.eventId}`] ? (
                        <span className="spinner-border spinner-border-sm"></span>
                      ) : (
                        <i className="fas fa-trash"></i>
                      )}
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <div className="text-center py-5">
          <i className="fas fa-calendar-alt text-muted mb-3" style={{ fontSize: '3rem' }}></i>
          <h6 className="text-muted">No Events Found</h6>
          <p className="text-muted">This club doesn't have any events yet.</p>
        </div>
      )}
    </div>
  );
};

export default ClubEvents;